// extracted by mini-css-extract-plugin
export default {"stack":"SelectionTiming_stack__YPGcA"};